// Names of the Internal areas, keyed by route segment. These are the only
// strings read through a variable rather than a literal — SideNav and the tab
// strips hand the key over as data — so collecting them here is what keeps the
// set auditable. A page heading reads its own segment rather than restating it.
import { BANK } from './bank'
import { FINANCE_TERMS } from './finance'
import { TERMS } from './terms'

export const NAV = {
  dashboard: 'Dashboard',
  projects: 'Projekte',
  properties: 'Objekte',
  matching: 'Matching',
  catalogue: 'Katalog',
  system: 'System',
  overview: TERMS.overview,
  documents: 'Dokumente',
  finance: 'Finanzen',
  contractParties: FINANCE_TERMS.partyPlural,
  paymentPlans: FINANCE_TERMS.paymentPlanPlural,
  bank: BANK.title,
  users: 'Benutzer',
  logs: TERMS.logs,
  queue: 'Queue',
  subscriptions: 'Abmeldungen',
  email: TERMS.email,
  emailLogs: 'Versand',
  administration: 'Verwaltung',
  operations: 'Betrieb',
  globalConfig: 'Einstellungen',
  // Short forms of the headings the pages themselves carry, for the narrow
  // second-level column: "Nicht zugeordnete Einheiten" does not fit in it.
  hubspot: 'HubSpot',
  emailConfig: 'E-Mail-Versand',
  defaultAdvisor: TERMS.contactPerson,
  listingCleanup: 'Bereinigung',
  ai: 'KI-Modelle',
  mcp: 'MCP',
  changeHistory: 'Änderungen',
  permissions: 'Berechtigungen',
  housekeeping: 'Housekeeping',
  suggestionPass: 'Vorschläge',
  mediaLibrary: 'Medien',
  imagePipeline: 'Bilder',
  elementTypes: TERMS.elementTypePlural,
  productProperties: TERMS.productPropertyPlural,
  backup: 'Backup',
  sync: 'Sync',
  configurator: TERMS.configurator,
  formulas: 'Formeln',
  otherProjects: 'Weitere Projekte',
  // Reached from a row rather than the rail, and named only where the
  // permissions page lists every route.
  customerView: 'Kundenansicht',
  customerArea: 'Kundenbereich',
} as const
